import { Navigate, type RouteObject } from 'react-router-dom';

import { RecordingPermissionGate } from '../components/guards/RecordingPermissionGate';

/**
 * Keep the historical recorder URL compatible after deleting the legacy recorder screen.
 * Recording permissions are evaluated before entering the permanent encounter flow.
 */
export const recordCompatibilityRoute: RouteObject = {
  path: '/record/',
  element: (
    <RecordingPermissionGate>
      <Navigate to="/encounters/active" replace />
    </RecordingPermissionGate>
  ),
};
